module.exports = __webpack_public_path__ + "static/media/stats@1.5x.54ffdb46.svg";